module.exports = __webpack_public_path__ + "static/media/logotext.399d9bd7.png";